import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { BgImage, Header, Intro, NewsWidget } from "@prmf/site-components";
import { routes, t } from "@prmf/site-router";
import { clsx } from "clsx";
import { useRef } from "react";

const timeline = [
  {
    author: "manhattan",
    title: "1946",
    text: "Dennis & Robinson founded in 1946 by George Dennis and Robbie Robinson. Manufacturing Clock cases in Portslade, East Sussex.",
    image: "/media/assets/history-milestone-1940.jpg",
  },
  {
    author: "manhattan",
    title: "Early 1950s",
    text: "Purchased by Smiths Industries, who were the principal supplier of instruments to the British car industry.",
    image: "/media/assets/history-early-1950.jpg",
  },
  {
    author: "manhattan",
    title: "Late 1950s",
    text: "Moved to Lancing Carriage Works which is still the current manufacturing site.",
    image: "/media/assets/history-milestone-1950.jpg",
  },
  {
    author: "manhattan",
    title: "Early 1960’s",
    text: "Began to manufacture fitted kitchens, when approached by a local estate agent.",
    image: "/media/assets/history-milestone-1960.jpg",
  },
  {
    author: "manhattan",
    title: "Early 1961",
    text: "Started trading under the name Manhattan Furniture, which was chosen as a reflection of the modern American lifestyle.",
    image: "/media/assets/history-1961.jpg",
  },
  {
    author: "paularosa",
    title: "1965",
    text: "Founded by David Robson (Kingfisher Wood Products Ltd). Manufacturing furniture from a farmer’s barn in Broadbridge Heath. First order was a sideboard for Mr & Mrs Hoyton £44–5 Shillings and 5D.",
    image: "/media/assets/history-milestone-1965.jpg",
  },
  {
    author: "paularosa",
    title: "Late 1960’s",
    text: "Produced kitchenettes for Butlins refurbishment and, with the company Egger, introduced MFC Furniture carcasses into the UK kitchen industry to replace existing plywood carcasses.",
    image: "/media/assets/history-milestone-late-1960.jpg",
  },
  {
    author: "paularosa",
    title: "1969",
    text: "Opened first retail showroom in Storrington.",
    image: "/media/assets/history-milestone-1969.jpg",
  },
  {
    author: "manhattan",
    title: "1970",
    text: "Opened a showroom in Brighton.",
    image: "/media/assets/history-1970.jpg",
  },
  {
    author: "paularosa",
    title: "1977",
    text: 'Opened new factory in Telford, focussing on public sector (council housing). Introduced "Paula Rosa" as brand name for retail showrooms - Named after daughter Paula and wife Rosemary. Introduced "Topaz" as brand name for public sector.',
    image: "/media/assets/history-milestone-1977.jpg",
  },
  {
    author: "paularosa",
    title: "1981",
    text: "Opened retail showrooms in Guildford and Brighton. Moved to one brand – Paula Rosa – across all sectors.",
    image: "/media/assets/history-1981.jpg",
  },
  {
    author: "paularosa",
    title: "1989",
    text: "Ballingslov purchased a 50% shareholding. Achieved FIRA Gold Certification for Product.",
    image: "/media/assets/history-1989.jpg",
  },
  {
    author: "paularosa",
    title: "1992",
    text: "Remaining 50% shareholding purchased by Ballingslov.",
    image: "/media/assets/history-1992.jpg",
  },
  {
    author: "manhattan",
    title: "1995",
    text: "Achieved FIRA Gold Certification for Product To Level H For Heavy Domestic Use.",
    image: "/media/assets/history-1995-01.jpg",
  },
  {
    author: "manhattan",
    title: "1999",
    text: "Achieved FIRA Gold Certification for Installation. First contract kitchen manufacturer to hold the FIRA Gold Award for both product and installation.",
    image: "/media/assets/history-milestone-1999.jpg",
  },
  {
    author: "manhattan",
    title: "Early 2000",
    text: "Manhattan worked with Cranfield University, leading to a refocus of the business on core processes and streamlining of the factory. This transformation allowed us to be more competitive and continue to win national deals with house builders but also, importantly, introduced Manhattan to the social housing sector.",
    image: "/media/assets/history-early-2000.jpg",
  },
  {
    author: "manhattan",
    title: "Early 2008",
    text: "Manhattan won a contract to deliver social-housing kitchens to Liverpool Mutual Homes and City West Housing, both projects encompassing about 12,000 kitchens.",
    image: "/media/assets/history-early-2008.jpg",
  },
  {
    author: "manhattan",
    title: "2011",
    text: "Achieved FIRA Gold Certification for Special Needs Kitchen Furniture.",
    image: "/media/assets/history-2011-01.jpg",
  },
  {
    author: "prmf",
    title: "2013",
    text: "Manhattan is Purchased by Ballingslöv Group of Companies and merged with Paula Rosa to create Paula Rosa Manhattan.",
    image: "/media/assets/history-2013-01.jpg",
  },
  {
    author: "prmf",
    title: "2015",
    text: "Ballingslöv Group inject over £10 million capital investment. The funding has achieved an unsurpassed world-class business – a leader in today’s UK contract kitchens market.",
    image: "/media/assets/history-milestone-2015.jpg",
  },
  {
    author: "prmf",
    title: "2018",
    text: "Re-launch of our state-of-the-art showrooms, the result of a substantial 0.5m investment.",
    image: "/media/assets/history-milestone-2018.jpg",
  },
  {
    author: "prmf",
    title: "2018",
    text: "Paula Rosa Manhattan won the prestigious project for Canary Wharf Contractors at Newfoundland to deliver 636 kitchens over 58 storeys.",
    image: "/media/assets/history-2018.jpg",
  },
  {
    author: "prmf",
    title: "2019",
    text: "Sustainability strategy launched to minimise our impact on the environment.",
    image: "/media/assets/history-2019-01.jpg",
  },
  {
    author: "prmf",
    title: "2020",
    text: "Our manufacturing carbon emissions per unit fall by an impressive 23% as our sustainability strategy goes from strength to strength.",
    image: "/media/assets/history-milestone-2020.jpg",
  },
  {
    author: "prmf",
    title: "2021",
    text: "Switched to renewable heating as we set our sights on a zero carbon production facility.",
    image: "/media/assets/history-milestone-2021.jpg",
  },
  {
    author: "prmf",
    title: "2022",
    text: "Acquired CHAS accreditation (Contractors’ Health and Safety Assessment Scheme, committed to setting health and safety benchmarks that drive industries forward and make the workplace safer).",
    image: "/media/assets/history-2022.jpg",
  },
  {
    author: "prmf",
    title: "2022",
    text: "Celebrated 10 years of zero manufacturing waste to landfill. Moved all timber product groups to FSC® certified suppliers. Introduced hydrotreated vegetable oil (biofuel) into our distribution fleet.",
    image: "/media/assets/history-2022-02.jpg",
  },
  {
    author: "prmf",
    title: "2023",
    text: "Proud to have become Living Wage certified.",
    image: "/media/assets/history-2022-03.jpg",
  },
];

export default function History() {
  const ref = useRef<HTMLUListElement>(null);
  return (
    <div>
      <Header
        image={t(routes.history, "image")}
        bgColor="black"
        title="Paula Rosa Manhattan – a member of Ballingslöv International Group with a history of kitchen manufacturing since 1929."
      >
        <p>
          Paula Rosa Manhattan is an established, trustworthy brand
          manufacturing in Sussex. We supply and install fitted kitchen
          furniture for national house builders, high-rise developers
          and social/affordable housing providers, as well as direct to the
          public.
        </p>
      </Header>
      <Intro
        title="Our experience, expertise and quality product, fully tested and certified, has stood the test of time with customers repeatedly returning for their next project."
        bgColor="black"
      />
      <div className="container pt-10">
        <h3>Timeline of key milestones</h3>
        <h4 className="mt-4 text-sm font-semibold">Key</h4>
        <div className="mt-2 flex gap-4 text-xs font-semibold text-white">
          <div className="rounded bg-blue-500 px-4 py-2">Manhattan events</div>
          <div className="rounded bg-green-400 px-4 py-2">
            Paula Rosa events
          </div>
        </div>
      </div>
      <div className="relative py-10">
        <ul
          ref={ref}
          className={clsx(
            "flex flex-nowrap gap-10 overflow-auto px-2",
            "no-scrollbar snap-x snap-mandatory scroll-smooth",
          )}
        >
          {timeline.map((t, i) => (
            <li
              key={i}
              className={clsx("min-w-[200px]", "snap-start scroll-ml-10")}
            >
              <BgImage src={t.image} className="aspect-square rounded" />
              <h3
                className={clsx(
                  "mb-2 mt-1 rounded p-2 text-sm font-medium text-white",
                  t.author === "manhattan"
                    ? "bg-blue-400"
                    : t.author === "paularosa"
                      ? "bg-green-500"
                      : "bg-black",
                )}
              >
                {t.title}
              </h3>
              <p className="text-xs leading-relaxed"> {t.text} </p>
            </li>
          ))}
        </ul>
        <div>
          <button
            className="absolute left-0 top-32 grid h-10 w-10 place-items-center bg-white"
            onClick={() =>
              ref.current?.scrollBy(ref.current?.offsetWidth * -1, 0)
            }
          >
            <ChevronLeftIcon className="h-8 w-8" />
          </button>
          <button
            className="grid-place-items-center absolute right-0 top-32 h-10 w-10 bg-white"
            onClick={() => ref.current?.scrollBy(ref.current?.offsetWidth, 0)}
          >
            <ChevronRightIcon className="h-8 w-8" />
          </button>
        </div>
      </div>
      <NewsWidget />
    </div>
  );
}
